
import {getJackpotHistoryList} from '../api/getJackpotHistoryList';
import {setGetJackpotHistoryListAction} from '../action';

const setGetJackpotHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getJackpotHistoryList(params);

            if (data.status === 'success') {
                dispatch(setGetJackpotHistoryListAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetJackpotHistoryList
}